module.exports = __webpack_public_path__ + "img/coin-1.540cb29d.png";